import React, { useState, useEffect, useCallback } from 'react';
import { Layout, Button, Modal, Typography, Row, Col, Tabs, Drawer, Menu } from 'antd';
import { MenuOutlined, UserOutlined, LogoutOutlined, DownOutlined } from '@ant-design/icons';
import Login from './login';
import RegisterForm from './Registration';
import { useStateContext } from '../../contexts/ContextProvider';
import { useNavigate } from 'react-router-dom'; 
import { ROLES } from '../../config/permissions';
import { message } from 'antd';
const { Header, Content, Footer } = Layout;
const { Title, Text, Paragraph } = Typography;

function PageTemplate({ children, title }) {
  const navigate = useNavigate();
  // State pentru controlul modalului


  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('login');
  const { user, removeToken, verificaUtilizator } = useStateContext();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  // Detectarea scroll-ului pentru a schimba stilul header-ului
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Funcții pentru deschiderea/închiderea modalului
  const showAuthModal = () => {
    setIsAuthModalOpen(true);
    setMobileMenuOpen(false);
  };

  const closeAuthModal = () => {
    setIsAuthModalOpen(false);
    // Eliminăm apelul automat către goToDashboard
  };

  // Funcție separată pentru succesul login-ului
  const handleLoginSuccess = () => {
    setIsAuthModalOpen(false);
    // Doar după login cu succes navigăm către dashboard
    setTimeout(() => {
      goToDashboard();
    }, 100);
  };

  // Handler pentru succesul înregistrării
  const handleRegisterSuccess = () => {
    setActiveTab('login');
  };

  const handleLogout = () => {
    removeToken();
    setMobileMenuOpen(false);
  };

  // Navigare către dashboard (doar pentru utilizatori autentificați)
  const goToDashboard = async () => {
    try {
      // Verificăm utilizatorul cu token-ul existent
      const userData = await verificaUtilizator(true); // forțăm refresh-ul
      console.log("userData", userData);
      if (userData && userData.role === ROLES.ADMIN) {
        // Utilizatorul este valid, navigăm către dashboard
        navigate('/dashboard');
      } else if (userData && userData.role === ROLES.WITHOUT_ADMIN) {
        // Utilizatorul este valid, navigăm către dashboard
        navigate('/dashboard/oferte');
      } else {
        // Token invalid sau inexistent, afișăm modalul de login
        showAuthModal();
        message.error('Token invalid sau inexistent');
      }
    } catch (error) {
      console.error("Eroare la verificarea utilizatorului:", error);
      // În caz de eroare, afișăm modalul de login
      showAuthModal();
    }
  };

  const items = [
    {
      key: 'login',
      label: 'Autentificare',
      children: <Login onSuccess={handleLoginSuccess} onCancel={closeAuthModal} />
    }
  ];

  const menuItems = [
    { key: 'home', label: 'Acasă', onClick: () => navigate('/') },
    { key: 'about', label: 'Despre Noi', onClick: () => navigate('/about') },
    { key: 'contact', label: 'Contact', onClick: () => setIsContactModalOpen(true) },
  ];

  return (
    <Layout className="min-h-screen">
      <Header 
        className={`fixed z-50 w-full transition-all duration-500 ${
          scrolled 
            ? 'bg-white/95 backdrop-blur-md shadow-lg border-b border-gray-100' 
            : 'bg-gradient-to-r from-blue-600 via-blue-500 to-indigo-600'
        }`}
        style={{ 
          padding: 0, 
          height: scrolled ? '70px' : '80px',
          borderBottom: scrolled ? '1px solid rgba(0,0,0,0.08)' : 'none'
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
          <Row justify="space-between" align="middle" className="h-full">
            {/* Logo Section */}
            <Col>
              <div 
                className="flex items-center cursor-pointer group transition-all duration-300"
                onClick={() => navigate('/')}
              >
                <div className="relative">
                  <img 
                    src="/Logo_Danco.png" 
                    alt="DANCO Logo" 
                    className={`transition-all duration-500 ${
                      scrolled 
                        ? 'h-12 md:h-14' 
                        : 'h-14 md:h-16'
                    } w-auto drop-shadow-md group-hover:scale-105`}
                  />
                  {!scrolled && (
                    <div className="absolute inset-0 bg-white/10 rounded-lg blur-xl group-hover:bg-white/20 transition-all duration-300"></div>
                  )}
                </div>
                <div className="ml-3 hidden sm:block">
                  <h1 className={`font-bold text-lg md:text-xl transition-all duration-300 ${
                    scrolled 
                      ? 'text-gray-800 group-hover:text-blue-600' 
                      : 'text-white group-hover:text-blue-100'
                  }`}>
                    DANCO
                  </h1>
                  <p className={`text-xs transition-all duration-300 ${
                    scrolled 
                      ? 'text-gray-500' 
                      : 'text-blue-100'
                  }`}>
                    Soluții Complete
                  </p>
                </div>
              </div>
            </Col>
            
            {/* Desktop Navigation */}
            <Col className="hidden lg:block">
              <nav className="flex items-center space-x-1">
                {menuItems.map((item) => (
                  <button
                    key={item.key}
                    onClick={item.onClick}
                    className={`px-4 py-2 rounded-lg font-medium text-sm transition-all duration-300 relative overflow-hidden group ${
                      (window.location.pathname === '/' ? 'home' : window.location.pathname.slice(1)) === item.key
                        ? scrolled
                          ? 'bg-blue-50 text-blue-600 shadow-sm'
                          : 'bg-white/20 text-white shadow-md'
                        : scrolled
                          ? 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'
                          : 'text-white hover:text-blue-100 hover:bg-white/10'
                    }`}
                  >
                    <span className="relative z-10">{item.label}</span>
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-indigo-500 opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
                  </button>
                ))}
              </nav>
            </Col>
            
            {/* Mobile Menu Button */}
            <Col className="block lg:hidden">
              <Button 
                icon={<MenuOutlined className="text-lg" />}
                onClick={() => setMobileMenuOpen(true)}
                className={`border-0 shadow-none transition-all duration-300 hover:scale-110 ${
                  scrolled 
                    ? 'text-gray-700 hover:text-blue-600 hover:bg-blue-50' 
                    : 'text-white hover:text-blue-100 hover:bg-white/10'
                }`}
                type="text"
                size="large"
                style={{ 
                  backgroundColor: 'transparent',
                  width: '48px',
                  height: '48px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '12px'
                }}
              />
            </Col>
          </Row>
        </div>
      </Header>

      {/* Enhanced Mobile Menu Drawer */}
      <Drawer
        title={
          <div className="flex items-center space-x-3">
            <img 
              src="/Logo_Danco.png" 
              alt="DANCO Logo" 
              className="h-8 w-auto"
            />
            <div>
              <h3 className="font-bold text-gray-800 text-lg">DANCO</h3>
              <p className="text-xs text-gray-500">Soluții Complete</p>
            </div>
          </div>
        }
        placement="right"
        onClose={() => setMobileMenuOpen(false)}
        open={mobileMenuOpen}
        width={280}
        className="mobile-menu-drawer"
        styles={{
          body: { padding: '0' },
          header: { borderBottom: '1px solid #f0f0f0', padding: '20px 24px' }
        }}
      >
        <div className="py-4">
          {menuItems.map((item, index) => (
            <button
              key={item.key}
              onClick={() => {
                item.onClick();
                setMobileMenuOpen(false);
              }}
              className={`w-full px-6 py-4 text-left transition-all duration-300 flex items-center space-x-3 group ${
                (window.location.pathname === '/' ? 'home' : window.location.pathname.slice(1)) === item.key
                  ? 'bg-blue-50 text-blue-600 border-r-3 border-blue-500'
                  : 'text-gray-700 hover:bg-gray-50 hover:text-blue-600'
              }`}
              style={{ 
                borderLeft: (window.location.pathname === '/' ? 'home' : window.location.pathname.slice(1)) === item.key 
                  ? '4px solid #3b82f6' 
                  : '4px solid transparent' 
              }}
            >
              <span className="font-medium">{item.label}</span>
              <div className="flex-1"></div>
              <div className={`transition-transform duration-300 ${
                (window.location.pathname === '/' ? 'home' : window.location.pathname.slice(1)) === item.key 
                  ? 'transform translate-x-0' 
                  : 'transform translate-x-2 opacity-0 group-hover:translate-x-0 group-hover:opacity-100'
              }`}>
                →
              </div>
            </button>
          ))}
          
          {/* Divider */}
          <div className="mx-6 my-4 border-t border-gray-200"></div>
          
          {/* Contact Info */}
          <div className="px-6 py-4 bg-gradient-to-r from-blue-50 to-indigo-50 mx-4 rounded-lg">
            <h4 className="font-semibold text-gray-800 mb-2">Contact</h4>
            <p className="text-sm text-gray-600 mb-1">📧 info@danco.md</p>
            <p className="text-sm text-gray-600 mb-1">📞 +373 78 888 001</p>
            <p className="text-sm text-gray-600">📍 Chișinău, str. Columna 102</p>
          </div>
        </div>
      </Drawer>

      <Content className="bg-gray-50" style={{ paddingTop: scrolled ? '70px' : '80px' }}>
        <div className="min-h-screen">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            {title && (
              <Title 
                level={2} 
                className="mb-8 text-center lg:text-left text-gray-800 font-bold"
                style={{ fontSize: '2rem', lineHeight: '2.5rem' }}
              >
                {title}
              </Title>
            )}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
              <div className="p-6 md:p-8">
                {children}
              </div>
            </div>
          </div>
        </div>
      </Content>

      <Footer className="bg-gray-900 text-white py-6 md:py-8">
        <div className="max-w-7xl mx-auto px-4">
          <Row gutter={[16, 24]}>
            <Col xs={24} md={8}>
              <div className="flex items-center mb-3 md:mb-4">
                <img 
                  src="/Logo_Danco.png" 
                  alt="DANCO Logo" 
                  className="h-8 w-auto mr-3"
                />
                <h2 className="text-white mb-0 text-xl md:text-2xl">DANCO</h2>
              </div>
              <Paragraph className="text-gray-400 mb-4">
                Soluții complete pentru grădinițe, școli și primării în Republica Moldova
              </Paragraph>
            </Col>
            
            <Col xs={24} md={8}>
              <h4 className="text-white mb-3 md:mb-4">Contact</h4>
              <p className="text-gray-400">Email: info@danco.md</p>
              <p className="text-gray-400">Telefon: +37378888001</p>
              <p className="text-gray-400">Adresa: Chișinău, str. Columna 102</p>
            </Col>
            
            <Col xs={24} md={8}>
              <h4 className="text-white mb-3 md:mb-4">Link-uri Rapide</h4>
              <div className="flex flex-col text-gray-400">
                <a onClick={() => navigate('/')} className="text-gray-400 hover:text-white py-1 cursor-pointer">Acasă</a>
                <a onClick={() => navigate('/about')} className="text-gray-400 hover:text-white py-1 cursor-pointer">Despre Noi</a>
                <a onClick={() => setIsContactModalOpen(true)} className="text-gray-400 hover:text-white py-1 cursor-pointer">Contact</a>
                {/* Link ascuns pentru acces angajați */}
                <div className="mt-4 border-t border-gray-700 pt-2">
                  <a 
                    href="#" 
                    onClick={(e) => {
                      e.preventDefault();
                      goToDashboard();
                    }} 
                    className="text-gray-600 text-xs hover:text-gray-400"
                  >
                    Acces Intern
                  </a>
                </div>
              </div>
            </Col>
          </Row>
          
          <div className="text-center mt-6 md:mt-8 pt-4 md:pt-6 border-t border-gray-800">
            <p className="text-gray-500 text-sm">© {new Date().getFullYear()} DANCO. Toate drepturile rezervate.</p>
          </div>
        </div>
      </Footer>

      {/* Modal comun pentru Login și Register */}
      <Modal
        title={null}
        open={isAuthModalOpen}
        onCancel={closeAuthModal}
        footer={null}
        destroyOnClose={true}
        width={800}
        className="auth-modal"
        centered
        bodyStyle={{ padding: "16px" }}
      >
        <Title level={4} className="text-center mb-4">Acces Administrare</Title>
        <Tabs 
          activeKey={activeTab} 
          onChange={setActiveTab}
          items={items}
          centered
          className="auth-tabs"
        />
      </Modal>

      {/* Contact Modal */}
      <Modal
        title={null}
        open={isContactModalOpen}
        onCancel={() => setIsContactModalOpen(false)}
        footer={null}
        width={500}
        className="contact-modal"
        centered
        bodyStyle={{ padding: "0" }}
      >
        <div className="bg-gradient-to-br from-blue-50 to-indigo-100 p-8 text-center">
          <div className="flex justify-center mb-6">
            <img 
              src="/Logo_Danco.png" 
              alt="DANCO Logo" 
              className="h-16 w-auto"
            />
          </div>
          <Title level={3} className="mb-2 text-gray-800">Contactați-ne</Title>
          <Paragraph className="text-gray-600 mb-8">
            Suntem aici pentru a vă ajuta cu toate întrebările și solicitările dumneavoastră
          </Paragraph>
          
          <div className="space-y-4">
            {/* Phone Contact */}
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="bg-green-100 p-3 rounded-full">
                    <span className="text-2xl">📞</span>
                  </div>
                  <div className="text-left">
                    <h4 className="font-semibold text-gray-800 mb-1">Telefon</h4>
                    <p className="text-gray-600">+373 78 888 001</p>
                  </div>
                </div>
                <Button 
                  type="primary" 
                  className="bg-green-500 hover:bg-green-600 border-green-500"
                  onClick={() => window.open('tel:+37378888001')}
                >
                  Sună Acum
                </Button>
              </div>
            </div>

            {/* Email Contact */}
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="bg-blue-100 p-3 rounded-full">
                    <span className="text-2xl">📧</span>
                  </div>
                  <div className="text-left">
                    <h4 className="font-semibold text-gray-800 mb-1">Email</h4>
                    <p className="text-gray-600">info@danco.md</p>
                  </div>
                </div>
                <Button 
                  type="primary" 
                  onClick={() => window.open('mailto:info@danco.md')}
                >
                  Trimite Email
                </Button>
              </div>
            </div>

            {/* Address */}
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="bg-purple-100 p-3 rounded-full">
                    <span className="text-2xl">📍</span>
                  </div>
                  <div className="text-left">
                    <h4 className="font-semibold text-gray-800 mb-1">Adresa</h4>
                    <p className="text-gray-600">Chișinău, str. Columna 102</p>
                  </div>
                </div>
                <Button 
                  type="default"
                  onClick={() => window.open('https://maps.google.com/?q=Chișinău, str. Columna 102', '_blank')}
                >
                  Vezi pe Hartă
                </Button>
              </div>
            </div>
          </div>

          {/* Program de lucru */}
          <div className="mt-8 p-4 bg-white/70 rounded-lg border border-white/50">
            <h4 className="font-semibold text-gray-800 mb-2">Program de lucru</h4>
            <div className="text-sm text-gray-600 space-y-1">
              <p>Luni - Vineri: 09:00 - 18:00</p>
              <p>Sâmbătă: 09:00 - 14:00</p>
              <p>Duminică: Închis</p>
            </div>
          </div>
        </div>
      </Modal>
      
      {/* Custom Styles */}
      <style jsx>{`
        .mobile-menu-drawer .ant-drawer-header {
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
        }
        
        .mobile-menu-drawer .ant-drawer-body {
          background: #fafafa;
        }
        
        @media (max-width: 1024px) {
          .desktop-nav {
            display: none;
          }
        }
        
        /* Smooth scrolling animations */
        html {
          scroll-behavior: smooth;
        }
        
        /* Logo glow effect */
        .logo-glow {
          filter: drop-shadow(0 0 10px rgba(59, 130, 246, 0.3));
        }
        
        /* Button hover effects */
        .nav-button:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
        
        /* Mobile menu animations */
        .mobile-menu-item {
          animation: slideInRight 0.3s ease-out;
        }
        
        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        /* Backdrop blur support */
        @supports (backdrop-filter: blur(10px)) {
          .header-blur {
            backdrop-filter: blur(10px);
          }
        }
      `}</style>
    </Layout>
  );
}

export default PageTemplate; 